import React, { useCallback, useEffect, useState } from "react";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CustomTab, {
  TabContainer,
} from "../../../components/tabs/customTabs";
import { useNavigate, useSearchParams } from "react-router-dom";
import PackageHistoryTable from "./components/packageTable";
import PaymentHistoryTable from "./components/paymentTable";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import StorageHistoryTable from "./components/storageTable";


const ManageHistory = () => {
  const { limit } = useSelector((state) => state.global);
  const [search, setSearch] = useState();
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [fetchMore, setfetchMore] = useState(false);
  const [tableData, setTableData] = useState();
  const [totalData, setTotalData] = useState();

  useEffect(() => {
    const tabFromUrl = searchParams.get("tab");
    if (tabFromUrl !== null && tabFromUrl !== undefined) {
      setActiveTab(tabFromUrl);
    }
  }, [searchParams]);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    navigate(`?tab=${tabId}`);
  };

  const items = [
    { label: "Manage History" },
  ];

  const tabs = [
    {
      id: "tab1",
      label: "Package History",
      content: (
        <div className="overflow-x-auto flex flex-col gap-2 p-4 w-full ">
          <PackageHistoryTable/>
        </div>
      ),
    },
    {
      id: "tab2",
      label: "Storage History",
      content: (
        <div className="flex flex-col gap-2 overflow-auto p-4 w-full">
          <StorageHistoryTable tableData={tableData} totalData={totalData} loading={loading}/>
        </div>
      ),
    },
    {
      id: "tab3",
      label: "Transaction Logs",
      content: (
        <div className="flex flex-col gap-2 overflow-auto p-4 w-full">
          <PaymentHistoryTable tableData={tableData} totalData={totalData} loading={loading}/>
        </div>
      ),
    },
    
  ];

  return (
    <div className={"flex flex-col"}>
      <PageTableHeader breadcrumbs={items} isSearch={false} isFilter={false} />

      <div className="flex flex-row gap-2">
        <div className="flex flex-col bg-white w-full">
          <div className="flex flex-row gap-4">
            <div className="flex flex-row items-center gap-4 text-theme font-bold">
              {/* <h2 className="text-theme font-bold text-sm">Templates</h2> */}
            </div>
            <CustomTab
              tabs={tabs}
              activeTab={activeTab}
              onTabChange={handleTabChange}
            />
          </div>
          <div className="-mt-4">
            <TabContainer tabs={tabs} activeTab={activeTab} />
          </div>
        </div>
      </div>
    </div>
  );
};



export default ManageHistory;
